import { c as n, cB as e, cNotM as v, cE as d, cM as c, cCB as m } from "./ghl-ui.es384.js";
import $ from "./ghl-ui.es1301.js";
const f = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, t = "var(--n-arrow-height) * 1.414", x = n([e("popover", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 position: relative;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 box-shadow: var(--n-box-shadow);
 word-break: break-word;
 `, [n(">", [e("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), v("raw", `
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 `, [v("scrollable", [v("show-header-or-footer", "padding: var(--n-padding);")])]), d("header", `
 padding: var(--n-padding);
 border-bottom: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), d("footer", `
 padding: var(--n-padding);
 border-top: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), c("scrollable, show-header-or-footer", [d("content", `
 padding: var(--n-padding);
 `)])]), e("popover-shared", `
 transform-origin: inherit;
 `, [
  e("popover-arrow-wrapper", `
 position: absolute;
 overflow: hidden;
 pointer-events: none;
 `, [e("popover-arrow", `
 transition: background-color .3s var(--n-bezier);
 position: absolute;
 display: block;
 width: calc(${t});
 height: calc(${t});
 box-shadow: 0 0 8px 0 rgba(0, 0, 0, .12);
 transform: rotate(45deg);
 background-color: var(--n-color);
 pointer-events: all;
 `)]),
  // body transition
  n("&.popover-transition-enter-from, &.popover-transition-leave-to", `
 opacity: 0;
 transform: scale(.85);
 `),
  n("&.popover-transition-enter-to, &.popover-transition-leave-from", `
 transform: scale(1);
 opacity: 1;
 `),
  n("&.popover-transition-enter-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-out),
 transform .15s var(--n-bezier-ease-out);
 `),
  n("&.popover-transition-leave-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-in),
 transform .15s var(--n-bezier-ease-in);
 `)
]), r("top-start", `
 top: calc(${t} / -2);
 left: calc(${o("top-start")} - var(--v-offset-left));
 `), r("top", `
 top: calc(${t} / -2);
 transform: translateX(calc(${t} / -2)) rotate(45deg);
 left: 50%;
 `), r("top-end", `
 top: calc(${t} / -2);
 right: calc(${o("top-end")} + var(--v-offset-left));
 `), r("bottom-start", `
 bottom: calc(${t} / -2);
 left: calc(${o("bottom-start")} - var(--v-offset-left));
 `), r("bottom", `
 bottom: calc(${t} / -2);
 transform: translateX(calc(${t} / -2)) rotate(45deg);
 left: 50%;
 `), r("bottom-end", `
 bottom: calc(${t} / -2);
 right: calc(${o("bottom-end")} + var(--v-offset-left));
 `), r("left-start", `
 left: calc(${t} / -2);
 top: calc(${o("left-start")} - var(--v-offset-top));
 `), r("left", `
 left: calc(${t} / -2);
 transform: translateY(calc(${t} / -2)) rotate(45deg);
 top: 50%;
 `), r("left-end", `
 left: calc(${t} / -2);
 bottom: calc(${o("left-end")} + var(--v-offset-top));
 `), r("right-start", `
 right: calc(${t} / -2);
 top: calc(${o("right-start")} - var(--v-offset-top));
 `), r("right", `
 right: calc(${t} / -2);
 transform: translateY(calc(${t} / -2)) rotate(45deg);
 top: 50%;
 `), r("right-end", `
 right: calc(${t} / -2);
 bottom: calc(${o("right-end")} + var(--v-offset-top));
 `), ...$({
  top: ["right-start", "left-start"],
  right: ["top-end", "bottom-end"],
  bottom: ["right-end", "left-end"],
  left: ["top-start", "bottom-start"]
}, (i, s) => {
  const a = ["right", "left"].includes(s), l = a ? "width" : "height";
  return i.map((p) => {
    const b = p.split("-")[1] === "end", g = `calc((${`var(--v-target-${l}, 0px)`} - ${t}) / 2)`, h = o(p);
    return n(`[v-placement="${p}"] >`, [e("popover-shared", [c("center-arrow", [e("popover-arrow", `${s}: calc(max(${g}, ${h}) ${b ? "+" : "-"} var(--v-offset-${a ? "left" : "top"}));`)])])]);
  });
})]);
function o(i) {
  return ["top", "bottom"].includes(i.split("-")[0]) ? "var(--n-arrow-offset)" : "var(--n-arrow-offset-vertical)";
}
function r(i, s) {
  const a = i.split("-")[0], l = ["top", "bottom"].includes(a) ? "height: var(--n-space-arrow);" : "width: var(--n-space-arrow);";
  return n(`[v-placement="${i}"] >`, [e("popover-shared", `
 margin-${f[a]}: var(--n-space);
 `, [c("show-arrow", `
 margin-${f[a]}: var(--n-space-arrow);
 `), c("overlap", `
 margin: 0;
 `), m("popover-arrow-wrapper", `
 right: 0;
 left: 0;
 top: 0;
 bottom: 0;
 ${a}: 100%;
 ${f[a]}: auto;
 ${l}
 `, [e("popover-arrow", s)])])]);
}
export {
  x as default
};
